import {
  CommonAriaTo1DSPropertiesAvailable,
  CommonNorthStarUserBiProperties,
  ContextColumnsBase,
} from "@mwt/web-js-telemetry";

export enum ScenarioName {
  LogAppSession = "logAppSession",
  CheckAuthSession = "checkAuthSession",
  StartAudioTest = "startAudioTest",
  AudioTestCallTimeout = "audioTestCallTimeout",
  CancelAudioTest = "cancelAudioTest",
  CompletedAudioTest = "completedAudioTest",
  DesktopPermissionsPromptModal = "DesktopPermissionsPromptModal",
  AudioTestSurvey = "audioTestSurvey",
  FinishBeforeAudioTest = "finishBeforeAudioTest",
  FinishAfterAudioTest = "finishAfterAudioTest",
  MicCamPermissionPrompt = "micCamPermissionPrompt",
  SubmitTestResults = "submitTestResults",
  SubmitTestResultsSuccess = "submitTestResultsSuccess",
  SubmitTestResultsFailure = "submitTestResultsFailure",
}

export enum ScenarioType {
  Initialization = "initialization",
  DeviceStatus = "deviceSelection",
  AudioTest = "audioTestCall",
  DeviceTestSession = "deviceTestSession",
}

export enum PanelType {
  GlobalError = "globalerror",
  LogAppSession = "logAppSession",
  AudioTest = "audioTest",
  Permission = "permission",
  TestResults = "testResults",
  AuthSession = "authSession",
}

export enum ModuleName {
  StartAudioTestButton = "Start Audio Test button",
  AudioTestCall = "Audio Test Call",
  AudioTestCallTimeoutPage = "audioTestCallTimeoutPage",
  CancelAudioTestButton = "Cancel Audio Test button",
  FinishTestButton = "Finish Test Button",
  AudioTestResultsClearButton = "Audio Test was clear button",
  AudioTestResultsUnclearButton = "Audio Test was unclear button",
  AuthSession = "Auth Session",
  AnonymousSession = "Anonymous Session",
  MicCamAccessPrompt = "Microphone and Camera Access Prompt",
  SubmitTestResultsButton = "Send test results to epic button",
  SubmitTestResultsSuccess = "Successfully sent test results",
  SubmitTestResultsFailure = "Failure in sending test results",
  DesktopPermissionsPromptModal = "Desktop Permissions Prompt Modal",
}

export enum ModuleSummary {
  StartAudioTestButton = "Start Audio Test event",
  CancelAudioTestButton = "Clicked button to cancel audio test after initiation",
  CompletedAudioTestCall = "Finished full audio test call",
  AudioTestCallTimeoutPage = "Audio test call did not connect within timeout window",
  FinishBeforeAudioTest = "Finished Device Test Session before audio test call",
  FinishAfterAudioTest = "Finished Device Test Session after audio test call",
  AudioTestClear = "Reported audio test call was clear so no issues with mic or speaker",
  AudioTestUnclear = "Reported audio test call was unclear so issue with mic or speaker",
  AllowMicCamAccess = "User allowed microphone and camera access",
  DenyMicCamAccess = "User denied microphone and camera access",
  SubmitTestResultsButton = "Button to send results to epic",
  AuthSession = "Recieved session context from url parameters so setting auth session variables",
  AnonymousSession = "No session context received so session is anonymous",
  SubmitTestResultsSuccess = "Successfully sent test results to epic",
  SubmitTestResultsFailure = "Failure in sending test results to epic",
  DesktopPermissionsPromptModalClosed = "Desktop Permissions Prompt Modal closed",
  DesktopPermissionsPromptModalOpened = "Desktop Permissions Prompt Modal open",
}

export enum RequestResult {
  Error = "error",
  NetworkError = "networkError",
}

export enum EventType {
  NonUiEvent = "nonuievent",
}
export enum CustomContextColumns {
  AppName = "App.Name",
  AuthSession = "AuthSession",
  TenantId = "TenantId",
}

export const ContextColumns = {
  ...ContextColumnsBase,
  ...CustomContextColumns,
};
export interface CustomContextProperties
  extends Omit<
    CommonNorthStarUserBiProperties,
    CommonAriaTo1DSPropertiesAvailable
  > {
  [CustomContextColumns.AppName]: string;
  [CustomContextColumns.AuthSession]: string;
  [CustomContextColumns.TenantId]: string;
}
